import { Button } from "@material-ui/core";
import React, { ReactElement, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components/macro";
import { launchExperience } from "../store/selections/selectionsActions";
import Logo from "./Logo";

const ShareScreenDiv = styled.div`
	margin: 30px;
	width: 100%;
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-x: hidden;
	text-align: center;
`;

const Subtitle = styled.div`
	padding: 30px;
	font-size: 24px;
	line-height: 28px;
	text-align: left;
`;
const LogoSpacer = styled.div`
	height: 50%;
`;
const ShareButton = styled(Button)`
	font-size: 30px;
	line-height: 36px;
	border-radius: 3px;
	padding: 25px 110px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const BackButton = styled(Button)`
	font-size: 24px;
	line-height: 30px;
	border-radius: 3px;
	padding: 15px 60px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const Blank = styled.div`
	flex: 1;
`;

const Code = styled.div`
	padding: 30px;
	font-size: 24px;
	font-weight: bold;
	line-height: 28px;
	text-align: center;
	overflow-wrap: anywhere;
`;

function ShareScreen(): ReactElement {
	const dispatch = useDispatch();
	const { code } = useParams<{ code: string }>();

	const onLaunch = () => {
		dispatch(launchExperience(code));
	};

	// Try sharing on page load, probably will be rejected
	useEffect(() => {
		onShare();
	}, []);

	const onShare = () => {
		const shareData = {
			title: "Lowe's Infinite Kitchen",
			//text: "View my custom kitchen in 3D!",
			url: process.env.PUBLIC_URL + "/#/" + code,
		};
		if (navigator.share) navigator.share(shareData).catch(() => console.log("Share call blocked"));
	};

	return (
		<ShareScreenDiv>
			<Logo />
			<LogoSpacer />
			<Subtitle>Share your kitchen with family and friends!</Subtitle>
			<Subtitle>Using code:</Subtitle>
			<Code>{code}</Code>
			<Blank />
			<ShareButton variant="contained" color="primary" onClick={onShare}>
				Share
			</ShareButton>
			<Blank />
			<BackButton variant="contained" color="secondary" onClick={onLaunch}>
				Back to Experience
			</BackButton>
			<Blank />
		</ShareScreenDiv>
	);
}

export default ShareScreen;
